import { Button, Grid } from "@mui/material";
import { useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";

interface IAcctionButtons {
  type: "submit" | "button";
  action(): void;
  handleClose(): void;
  title: string;
}

export function AcctionButtons(props: IAcctionButtons) {
  const { type, action, handleClose, title } = props;

  const text = useAppSelector(selectText);
  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        xl={6}
        sx={{
          paddingTop: 0,
          paddingLeft: 0,
          padding: 0,
          marginBottom: 2,
        }}
      >
        <Button variant="contained" fullWidth onClick={action} type={type} color="primary" id="action_button">
          {title}
        </Button>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        xl={6}
        sx={{
          paddingTop: 0,
          paddingLeft: 0,
          padding: 0,
        }}
      >
        <Button variant="contained" fullWidth onClick={handleClose} type="button" color="secondary">
          {text.cancel}
        </Button>
      </Grid>
    </Grid>
  );
}
